<template>
  <div class="box">
    <div class="box-header">
      <div class="col-12 div-btn-novo">
        <button id="newButton" class="btn btn-sm btn-success" @click="gravar()" data-tooltip="Gravar">
          Gravar
        </button>
       </div>
    </div>
		<div v-show="errorMessage != ''" class="alert alert-danger">{{ errorMessage }}</div>
		<div v-show="successMessage != ''" class="alert alert-success">{{ successMessage }}</div>

    <vuetable ref="vuetable"
      :api-mode="false"
			:data-manager="dataManager"
      :http-options="httpOptions"
      :fields="fields"
      :sort-order="sortOrder"
      :css="css.table"
      pagination-path=""
      :per-page="perPage"
      @vuetable:loading="onLoading"
      @vuetable:loaded="onLoaded"
      no-data-template="Nenhum registro encontrado"
    >
      <template slot="ativo" slot-scope="props">
        <toggle-button v-model="props.rowData.isAtivo"/>
      </template>
      <template slot="namespace_template_parceiro" slot-scope="props">
        <input v-model="props.rowData.namespace_template_parceiro" type="text" class="form-control" v-bind:class="{ 'box-input-required': props.rowData.errors.namespace_template_parceiro }">
      </template>
      <template slot="nome_template_parceiro" slot-scope="props">
        <input v-model="props.rowData.nome_template_parceiro" type="text" class="form-control" v-bind:class="{ 'box-input-required': props.rowData.errors.nome_template_parceiro }">
      </template>
    </vuetable>
  </div>
</template>

<script>
import Vue from 'vue'
import { Vuetable } from 'vuetable-2'
import VuetableCss from './../../helpers/VuetableCss'
import ToggleButton from 'vue-js-toggle-button'

import ActionsLogin from '../../actions/LoginActions'
import MensagemConfigActions from '../../actions/MensagemConfigActions'

Vue.use(ToggleButton)

export default {
  name: 'listar',
  components: {
    Vuetable
  },
  data () {
    return {
      css: VuetableCss,
      filterText: '',
      perPage: 25,
      errorMessage: '',
      successMessage: '',
      fields: [
        {
          name: 'desc_status_motorista',
          title: 'Status',
          sortField: 'desc_status_motorista'
        },
        {
          name: '__slot:ativo',
          title: 'Ativo',
          sortField: 'ativo'
        },
        {
          name: '__slot:namespace_template_parceiro',
          title: 'Namespace',
          sortField: 'namespace_template_parceiro'
        },
        {
          name: '__slot:nome_template_parceiro',
          title: 'Template',
          sortField: 'nome_template_parceiro'
        }
      ],
      sortOrder: [
        { field: 'desc_status_motorista', direction: 'asc' }
      ],
      data: []
    }
  },
  watch: {
    data (newVal, oldVal) {
      this.$refs.vuetable.refresh()
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Listar'

    this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))

    this.loadData()
  },
  computed: {
    httpOptions () {
      return { headers: { 'Authorization': 'Bearer ' + ActionsLogin.getToken() } }
    }
  },
  methods: {
    onLoading () {
      this.$parent.$parent.$data.showModalLoader = true
    },
    onLoaded () {
      this.$parent.$parent.$data.showModalLoader = false
    },
    dataManager (sortOrder, pagination) {
      if (this.data.length < 1) return

      let local = this.data

      pagination = this.$refs.vuetable.makePagination(
        local.length,
        this.perPage
      )

      local.forEach(i => {
        i.isAtivo = i.ativo === 1
        i.errors = {}
      })

      return {
        pagination: pagination,
        data: local
      }
    },
    loadData () {
      this.onLoading()

      MensagemConfigActions.listar()
        .then(res => {
          this.data = res.data

          this.onLoaded()
        })
        .catch((error) => {
          console.log(error.message)

          this.onLoaded()
        })
    },
    gravar () {
      let hasError = false
      let registros = []

      this.successMessage = ''
      this.errorMessage = ''

      this.data.forEach(i => {
        i.errors = {}
        i.ativo = i.isAtivo ? 1 : 2

        if (i.isAtivo) {
          if (!i.namespace_template_parceiro) {
            i.errors.namespace_template_parceiro = 'Este campo deve ser preenchido.'
            hasError = true
          }
          if (!i.nome_template_parceiro) {
            i.errors.nome_template_parceiro = 'Este campo deve ser preenchido.'
            hasError = true
          }
        }

        registros.push({
          cd_status_motorista: i.cd_status_motorista,
          namespace_template_parceiro: i.namespace_template_parceiro,
          nome_template_parceiro: i.nome_template_parceiro,
          ativo: i.ativo,
          created_by: ActionsLogin.getUsuario().cd_usuario,
          updated_by: ActionsLogin.getUsuario().cd_usuario
        })
      })

      if (!hasError) {
        this.onLoaded()

        MensagemConfigActions.gravar(registros)
          .then(response => {
            this.onLoaded()

            if (response.data.success) {
              this.successMessage = 'Alterações gravadas com sucesso'
            } else {
              this.errorMessage = 'Ocorreu um erro ao gravar o registro.'
            }

            this.loadData()
          })
          .catch((error) => {
            console.log(error.message)
            this.errorMessage = 'Ocorreu um erro ao gravar o registro.'
            this.onLoaded()
          })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/mensagem-config/Listar.vue